/**
 * DVL FAQ accordion enhancer (standalone)
 * =======================================
 * Upgrades EQA-rendered, div-based FAQ items into a collapsible accordion,
 * paired with the .dvl-faq--collapsible / .is-open rules in product-description.css.
 * Ported from Dawn's product-description-tabs.liquid so the non-Dawn themes
 * (galleria / prestige / fashionopolism), which lack that tabs component, get the
 * same click-to-expand FAQ. Native <details> FAQs are left untouched; the toggle
 * is delegated on document so it survives per-variant description swaps.
 */
(function () {
  'use strict';
  var OPEN = 'is-open';

  function enhanceFaqs(root) {
    var items = (root || document).querySelectorAll('div.dvl-faq-item:not([data-dvl-faq])');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var q = item.querySelector(':scope > .dvl-faq-question');
      var a = item.querySelector(':scope > .dvl-faq-answer');
      if (!q || !a) continue;                 // not a Q/A pair — skip
      item.setAttribute('data-dvl-faq', '');  // idempotency guard

      var faq = item.closest('.dvl-faq');
      if (faq) faq.classList.add('dvl-faq--collapsible');

      // Replace the literal trailing " +" baked into the question text with a
      // real element we can rotate on open (some questions ship without it).
      if (!q.querySelector('.dvl-faq-indicator')) {
        var last = q.lastChild;
        while (last && last.nodeType === 3 && !last.nodeValue.trim()) { last = last.previousSibling; }
        if (last && last.nodeType === 3) { last.nodeValue = last.nodeValue.replace(/\s*\+\s*$/, ''); }
        var ind = document.createElement('span');
        ind.className = 'dvl-faq-indicator';
        ind.setAttribute('aria-hidden', 'true');
        ind.textContent = '+';
        q.appendChild(ind);
      }

      q.setAttribute('role', 'button');
      q.setAttribute('tabindex', '0');
      q.setAttribute('aria-expanded', 'false');
    }
  }

  function toggle(item) {
    var open = item.classList.toggle(OPEN);
    var q = item.querySelector(':scope > .dvl-faq-question');
    if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Only div-based items react here; a <summary> inside a <details> has its parent
  // as <details>, so `div.dvl-faq-item` fails to match and the native toggle wins.
  function questionItem(el) {
    var q = el && el.closest && el.closest('.dvl-faq-question');
    if (!q || !q.parentElement || !q.parentElement.matches) return null;
    return q.parentElement.matches('div.dvl-faq-item') ? q.parentElement : null;
  }

  document.addEventListener('click', function (e) {
    var item = questionItem(e.target);
    if (item) toggle(item);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var item = questionItem(e.target);
    if (!item) return;
    e.preventDefault();
    toggle(item);
  });

  function run() { enhanceFaqs(document); }

  // Debounced re-run — coalesces bursts of DOM writes into one enhance pass.
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 60); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // A second pass after full load: on themes with a tabbed description the tab
  // builder MOVES / rebuilds the FAQ markup after DOMContentLoaded, so the first
  // pass may have run on the pre-tab DOM.
  window.addEventListener('load', schedule);

  // Re-enhance after a theme section (re)builds or the variant switcher swaps in
  // fresh per-variant description markup (deferred so it runs after that DOM write).
  ['shopify:section:load', 'dvl:rebuild-tabs', 'variant:changed', 'variantChange', 'theme:variant:change']
    .forEach(function (ev) { document.addEventListener(ev, schedule); });

  // Re-run across the mobile breakpoint, in case a theme restores pristine markup.
  var mq = window.matchMedia('(max-width: 768px)');
  var onMq = function () { schedule(); };
  if (mq.addEventListener) { mq.addEventListener('change', onMq); }
  else if (mq.addListener) { mq.addListener(onMq); }

  // Self-healing: the tabbed-description builders on some themes move / restore /
  // rebuild the FAQ nodes at times we can't predict (and older builders don't fire
  // dvl:rebuild-tabs). A MutationObserver catches any FAQ item that reappears
  // un-enhanced and upgrades it — idempotent (the data-dvl-faq guard), and it only
  // re-runs when a genuinely un-enhanced item is present, so it settles immediately.
  if (window.MutationObserver && document.body) {
    var mo = new MutationObserver(function () {
      if (document.querySelector('div.dvl-faq-item:not([data-dvl-faq])')) schedule();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
